import { Fetch } from '../helpers/fetchWrapper';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const knowledgebaseService = {
  _url: process.env.REACT_APP_KNOWLEDGE_BASE_API_URL,

  async KnowledgebaseUpload(payload, body) {
    return await Fetch.upload(
      `${this._url}/upload?user_id=${payload.user_id}&platform_id=${payload.platform_id}&agent_id=${payload.agent_id}`,
      'POST',
      body,
    );
  },
  async deleteKnowledgebase(payload) {
    return await Fetch.delete(`${this._url}/delete?agent_id=${payload.agent_id}&file_id=${payload.file_id}`);
  },
  async getKnowledgebaseDocs(payload) {
    return await Fetch.get(
      `${this._url}/details?user_id=${payload.user_id}&platform_id=${payload.platform_id}&agent_id=${payload.agent_id}`,
    );
  },
};

export default knowledgebaseService;
